module.exports = __webpack_public_path__ + "img/comparer-purple-circles.cd0258c7.svg";